const flashMessage = document.getElementById("flash-message");
if (flashMessage) {
  setTimeout(() => {
    flashMessage.style.transition = "opacity 0.5s";
    flashMessage.style.opacity = "0";
    setTimeout(() => {
      flashMessage.classList.add("hidden");
    }, 500);
  }, 3000); 
}